import { memo } from 'react';

import { Widget } from '@/components/ui/widget';
import type {
  BoxSection,
  BoxView
} from '@/components/ui/widget/views/box/box.view.type';
import type { WidgetData } from '@/components/ui/widget/widget.type';
import { BoxSectionContext } from './box.context';

type BoxViewProps = {
  view: BoxView;
  data: WidgetData;
};

type BoxItemProps = {
  index: number;
  item: BoxSection;
  data: WidgetData;
};

export const BoxItem = memo(({ index, item, data }: BoxItemProps) => (
  <BoxSectionContext.Provider value={{ index }}>
    {/* @ts-expect-error should be fixed when Widget is typed */}
    <Widget data={data} widget={item} />
  </BoxSectionContext.Provider>
));

export const BoxViewImpl = memo(({ view, data }: BoxViewProps) => (
  <div className="flex flex-col">
    {view.sections &&
      view.sections.map((item, index) => (
        <BoxItem
          data={data}
          index={index}
          item={item}
          key={item.view?.title ?? index}
        />
      ))}
  </div>
));

export const boxViewProvider = {
  component: BoxViewImpl
};
